module.exports = __webpack_public_path__ + "img/PD_1.41318c95.png";